var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveChatClearChat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.215,
    height: 16.2,
    viewBox: "0 0 16.215 16.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clear_chat",
    "data-name": "Clear chat",
    transform: "translate(0.615 0.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chatbubble-outline",
    d: "M.5,7.825A7.515,7.515,0,0,1,15.338,6.33a7.358,7.358,0,0,1-7.15,8.894H8.121a9.04,9.04,0,0,1-2.032-.3,11.091,11.091,0,0,1-1.1-.368,1.058,1.058,0,0,0-.4-.074,1.118,1.118,0,0,0-.434.088l-2.445.884a.637.637,0,0,1-.169.044.346.346,0,0,1-.346-.346h0a.333.333,0,0,1,.022-.118l.707-2.562a.857.857,0,0,0-.14-.537c-.029-.044-.059-.1-.088-.14a7.227,7.227,0,0,1-.847-1.767",
    transform: "translate(-0.5 -0.497)",
    fill: "none",
    stroke: "#1f1f1f",
    strokeLinecap: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "close",
    d: "M11.169,10.481l1.963-1.963a.489.489,0,0,0,0-.7.5.5,0,0,0-.7,0h0L10.471,9.783,8.507,7.819a.494.494,0,0,0-.7.7l1.963,1.963L7.81,12.444a.494.494,0,0,0,.7.7l1.963-1.963,1.963,1.963a.494.494,0,0,0,.7-.7Z",
    transform: "translate(-2.975 -2.976)",
    fill: "#1f1f1f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveChatClearChat);
export default __webpack_public_path__ + "static/media/live-chat-clear-chat.7b1f55a0b78f92bd37369f7acb43c10d.svg";
export { ForwardRef as ReactComponent };